import { render, staticRenderFns } from "./NewModule.vue?vue&type=template&id=1f0f7def&"
import script from "./NewModule.vue?vue&type=script&lang=ts&"
export * from "./NewModule.vue?vue&type=script&lang=ts&"
import style0 from "./NewModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewModule.vue"
export default component.exports